"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: "fill-primary"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.06,15.22,15.54,12.7l-2.83,2.84,2.53,2.52a4.48,4.48,0,0,0,1.08,4.62,4.35,4.35,0,0,0,4.86,1,.49.49,0,0,0,.15-.82L19.5,21.05V19.5h1.55l1.77,1.83a.49.49,0,0,0,.82-.15,4.47,4.47,0,0,0-5.58-6Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.94,8.78l2.51,2.51,2.84-2.84L8.76,5.94A4.48,4.48,0,0,0,7.68,1.32a4.35,4.35,0,0,0-4.86-1,.51.51,0,0,0-.3.37.51.51,0,0,0,.15.45L4.5,3V4.5H3L1.18,2.67a.51.51,0,0,0-.45-.15.51.51,0,0,0-.37.3,4.47,4.47,0,0,0,5.58,6Z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.78,18.06a4.47,4.47,0,0,1-6,5.58.49.49,0,0,1-.15-.82L4.5,21.05V19.5H3L1.18,21.33a.51.51,0,0,1-.45.15.51.51,0,0,1-.37-.3,4.35,4.35,0,0,1,1-4.86,4.48,4.48,0,0,1,4.62-1.08l9.28-9.3a4.47,4.47,0,0,1,6-5.58.51.51,0,0,1,.3.37.51.51,0,0,1-.15.45L19.5,3V4.5h1.55l1.77-1.83a.49.49,0,0,1,.82.15,4.35,4.35,0,0,1-1,4.86,4.48,4.48,0,0,1-4.62,1.08Z"
  })));
};

exports["default"] = _default;